'use client';

import { motion } from 'framer-motion';
import Link from 'next/link';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function OpsVisHero() {
  return (
    <section className="py-20 md:py-32 mt-16">
      <div className="container max-w-7xl">
        <motion.div
          className="max-w-4xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <motion.h1
            className="text-5xl sm:text-6xl lg:text-[64px] font-black leading-[1.05] tracking-tight mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Financial Intelligence
            <br />
            for <span className="gradient-text">AI Products</span>
          </motion.h1>

          <motion.p
            className="text-xl sm:text-[22px] text-muted-foreground max-w-[680px] leading-relaxed mb-10"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Design your monetization model. Meter usage. Automate billing. Prove ROI.
            <br />
            Know your margins on every customer, every offering, every invoice.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-3 mb-14"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <Link
              href="/handler/sign-up"
              className={cn(
                buttonVariants({ size: 'lg' }),
                'gradient-primary text-white hover:opacity-90 transition-opacity px-9 py-4 text-[17px]'
              )}
            >
              Start Free
            </Link>
            <Link
              href="#contact"
              className={cn(
                buttonVariants({ variant: 'outline', size: 'lg' }),
                'px-9 py-4 text-[17px]'
              )}
            >
              Book a Demo
            </Link>
          </motion.div>

          <motion.div
            className="flex gap-12 pt-9 border-t border-border"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <div>
              <div className="text-[28px] font-extrabold tracking-tight">17+</div>
              <div className="text-xs text-muted-foreground mt-0.5">AI providers</div>
            </div>
            <div className="w-px bg-border" />
            <div>
              <div className="text-[28px] font-extrabold tracking-tight">&lt; 5 min</div>
              <div className="text-xs text-muted-foreground mt-0.5">SDK setup</div>
            </div>
            <div className="w-px bg-border" />
            <div>
              <div className="text-[28px] font-extrabold tracking-tight">Real-time</div>
              <div className="text-xs text-muted-foreground mt-0.5">margin tracking</div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
